import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import Amain from './Amain';
import Hero from './Hero';
import SuperAdminDashboard from './SupperAdmin';
import Advancepaper from './Advancepaper'
import Carrier from './Carrier.js'
import Terms from './TermsOfService.js'
import Privacy from './PrivacyPolicy.js'
import Cookies from './CookiePolicy.js'
import Refund from './Refunds.js'
import Shipment from './Shipment.js'
import Contact from './Contact.js'
import About from './Aboutus.js'
import Blog from './Blog.js'
import Job from './Job.js'
import GDPR from './Gdpr.js'
import Check from './Pilgarism.js'
import Thesis from './Thesis.js'



function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Default homepage */}
          <Route path="/" element={<Hero />} />

          {/* Super Admin page */}
          <Route path="/superadmin" element={<SuperAdminDashboard />} />
          {/* <Route path="/advance" element={<Advancepaper />} /> */}
           <Route path="/carrier" element={<Carrier />} />
           <Route path="/terms" element={<Terms />} />
           <Route path="/privacy" element={<Privacy />} />
           <Route path="/cookies" element={<Cookies/>} />
            <Route path="/refunds" element={<Refund/>} />
              <Route path="/shipping" element={<Shipment/>} />
               <Route path="/contact" element={<Contact/>} />
               <Route path="/about" element={<About/>} />
                <Route path="/blog" element={<Blog/>} />
                  <Route path="/job" element={<Job/>} />
                   <Route path="/gdpr" element={<GDPR/>} />
                    {/* <Route path="/check" element={<Check/>} /> */}
                    <Route path="/thesis" element={<Thesis/>} />

        </Routes>
      </div>
    </Router>
  );
}

export default App;
